import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpCompetitions
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * A panel that shows the number of competing capacities and can fold out for a more detailed view.
     * If there are no competitions, nothing will be displayed.
     *
     * @param {string|number} auctionId The id of the auction to list competing capacities for.
     * @param {boolean} isReverse Whether or not it's a reverse auction. Defaults to false.
     * @param {boolean] isLoading Flag which is set to false, when loading finished
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpCompetitions', pkpCompetitions);

    function pkpCompetitions(auctionResource) {
        return {
            restrict: 'E',
            scope: {
                auctionId: '=',
                isReverse: '=?',
                isLoading: '=?',
                isReporting: '=?'
            },
            template: require('app/_directives/pkp-competitions.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.competitions = [];
            scope.competingAuctionsCount = 0;
            scope.isReverse = scope.isReverse === true;
            scope.uiLoading = true;
            scope.uiLoadingError = false;
            scope.addBundledAndDirectionFlag = addBundledAndDirectionFlag;

            var unbindAuctionIdWatcher = scope.$watch(
                function () {
                    return scope.auctionId;
                },
                function (newAuctionId) {
                    if (!newAuctionId) {
                        return;
                    }

                    getAuctionCompetitions(newAuctionId);
                    unbindAuctionIdWatcher();
                }
            );

            function getAuctionCompetitions(auctionId) {
                auctionResource
                    .getAuctionCompetitions(
                        { auctionId: auctionId },
                        function (res) {
                            scope.competitions = res.competitions;
                            scope.competingAuctionsCount =
                                res.competingAuctionsCount;
                        },
                        function () {
                            scope.uiLoadingError = true;
                        }
                    )
                    .$promise.finally(function () {
                        scope.uiLoading = false;
                        if (angular.isDefined(scope.isLoading)) {
                            scope.isLoading = false;
                        }
                    });
            }

            /**
             * Like for network points it adds an attribute `bundled` and `direction` to the object.
             *
             * @param {Object} competitionAuction The object to add the flags to.
             * @returns {Object} `competitionAuction` with `bundled` (boolean) and and `direction` (string) added.
             */
            function addBundledAndDirectionFlag(competitionAuction) {
                competitionAuction.bundled = !!(
                    competitionAuction.direction0 &&
                    competitionAuction.direction1
                );

                if (competitionAuction.bundled) {
                    competitionAuction.direction = 'BUNDLED';
                } else {
                    competitionAuction.direction =
                        competitionAuction.direction0;
                }

                return competitionAuction;
            }
        }
    }
})();
